import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/landingPage/Header";
import SideBar from "../../../components/b2b/SideBar";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";

function InvoiceRecords() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { invoiceRecord } = useSelector((state) => state.invoicerecord);
  const [isDeleteInvoice, setisDeleteInvoice] = useState();

  useEffect(() => {
    dispatch({
      type: "GET_ALL_INVOICE_RECORDS",
      payload: { token: token },
    });
  }, []);

  const columns = [
    { id: "invoiceid", label: "Invoice\u00a0Id", minWidth: 90 },
    { id: "invoicedate", label: "Invoice\u00a0Date", minWidth: 120 },
    {
      id: "invoiceCurrency",
      label: "Invoice\u00a0Currency",
      minWidth: 90,
      align: "right",
    },
    {
      id: "invoiceAmount",
      label: "Invoice\u00a0Amount",
      minWidth: 90,
      align: "right",
      // format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 90,
      align: "right",
    },
  ];

  return (
    <div className="fixed w-screen h-screen ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen h-screen overflow-y-auto">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <Paper sx={{ width: "90%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead
                    sx={{
                      backgroundColor: "#EFEFEF",
                    }}
                  >
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceRecord
                      // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((invoice) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={invoice?._id}
                          >
                            <TableCell
                              className="border "
                              // key={column.id}
                              // align={column.align}
                            >
                              {invoice?.invoiceNumber}
                            </TableCell>
                            <TableCell
                              className="border "
                              // key={column.id}
                              // align={column.align}
                            >
                              {moment(invoice?.invoiceDate).format(
                                "DD-MM-YYYY"
                              )}
                            </TableCell>

                            <TableCell
                              sx={{
                                fontSize: "12px",
                              }}
                              className="border "
                              // key={column.id}
                              // align={column.align}
                            >
                              {invoice?.invoiceCurrency}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                              }}
                              className="border "
                              // key={column.id}
                              // align={column.align}
                            >
                              {Math.ceil(invoice?.invoiceTotal)}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                color: "blue",
                              }}
                              className="border "
                              // key={column.id}
                              // align={column.align}
                            >
                              <Link to={`/docketInvoice/${invoice?._id}`}>
                                Edit
                              </Link>
                              <button
                                onClick={() => {
                                  setisDeleteInvoice(invoice?.invoiceNumber);
                                }}
                                className="px-4 text-red-600"
                              >
                                Delete
                              </button>
                              {isDeleteInvoice === invoice?.invoiceNumber && (
                                <div>
                                  <div> Are you sure you want to delete ? </div>
                                  <div className="flex space-x-3 justify-around">
                                    <Button
                                      onClick={() => {
                                        setisDeleteInvoice();
                                      }}
                                      color="secondary"
                                    >
                                      No
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        dispatch({
                                          type: "DELETE_INVOICE_RECORD",
                                          payload: {
                                            token: token,
                                            invoiceNumber:
                                              invoice?.invoiceNumber,
                                          },
                                        });
                                      }}
                                    >
                                      Yes
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoiceRecords;
